import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconMap"><Path d="M3.1966 5.56017L8 3.95904L8 18.5402L4.3034 19.7724C3.17022 20.1501 2 19.3067 2 18.1122V7.22037C2 6.46712 2.482 5.79837 3.1966 5.56017Z" fill="currentColor"/><Path d="M14.5 20.0535L9.5 18.5151L9.5 3.94568L14.5 5.48414L14.5 20.0535Z" fill="currentColor"/><Path d="M16 20.0402L20.8034 18.439C21.518 18.2008 22 17.5321 22 16.7789V5.88704C22 4.69256 20.8298 3.84911 19.6966 4.22684L16 5.45904L16 20.0402Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMap;
